import React from 'react';
import ServicesSection from '../components/sections/ServicesSection';

const ServicesPage = () => {
  return (
    <div className="pt-20">
      <ServicesSection />
    </div>
  );
};

export default ServicesPage;